import React, { useState, useEffect } from 'react';
import {
  Typography,
  Form,
  Select,
  notification,
  Input,
  Space,
  Descriptions,
  Alert,
  Layout,
  Skeleton,
  Card,
} from 'antd';

import CustomButton from '../../../components/CustomButton';
import {
  put,
  get,
  announcementInfo,
} from '../../../api/module/announcement_selection';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { get as getResume } from '../../../api/module/contractor';
import { filter } from '../../../api/module/resume_training';

import './style.scss';
import { get as getDocumentUrl } from '../../../api/module/document_repository';
import { useParams } from 'react-router-dom';

const { Title, Text } = Typography;
const { TextArea } = Input;
const { Content } = Layout;

const tailLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const AnnouncementSelectionValidationEducation = ({ history }) => {
  const { announcement_id, announcement_rol_id, selection_id, person_id } =
    useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(true);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [education, setEducation] = useState(null);

  const optionPreselection = [
    { id: 24, nombre: 'Pendiente' },
    { id: 25, nombre: 'Cumple' },
    { id: 26, nombre: 'No cumple' },
  ];
  const [name, setName] = useState('');

  const breadcrumbItems = [
    {
      text: 'Selección',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION}`,
    },
    {
      text: 'Validación',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
    },
    {
      text: 'Validación educación',
    },
  ];

  const back = () => {
    history.push(
      `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
    );
  };

  const onFinish = async (data) => {
    try {
      setLoading(true);
      initialValues.observacion_educacion_seleccion =
        data.observacion_educacion_seleccion;
      initialValues.estado_educacion_seleccion =
        data.estado_educacion_seleccion;
      delete initialValues.tercero_data;
      const response = await put(selection_id, initialValues);
      if ([200, 201, 204].indexOf(response.status) > -1) {
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
        setTimeout(() => {
          history.push(
            `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
          );
          setLoading(false);
        }, MESSAGES.TIME);
      }
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 2,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    getName();
    getAnnouncement();
    getEducation();
    getSelection();
  }, []);

  const getAnnouncement = async () => {
    try {
      const { data: aData } = await announcementInfo(announcement_rol_id);
      setInfo(aData);
      setLoadingForm(false);
    } catch (err) {
      console.log(err);
    }
  };

  const getSelection = async () => {
    try {
      const response = await get(selection_id);
      setInitialValues(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getEducation = async () => {
    const response = await filter('?filter[tercero]=' + person_id);
    setEducation(response.data.results);
  };

  const getName = async () => {
    const response = await getResume(person_id);
    setName(
      `${response.data.numero_identificacion} - ${response.data.nombre_completo}`,
    );
  };

  const showDocument = async (documento_nombre) => {
    setLoadingDocument(true);
    const response = await getDocumentUrl(documento_nombre);

    window.open(response.data.url);

    setLoadingDocument(false);
  };

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Módulo de Selección
      </Title>
      <Skeleton loading={loadingForm} active>
        {!!info ? (
          <Card
            size={'small'}
            bordered={false}
            title={<Title level={3}>Validación de educación</Title>}
          >
            <Descriptions
              layout="vertical"
              title="Información de convocatoria"
              column={2}
              bordered
            >
              <Descriptions.Item label="Número de convocatoria">
                {info.convocatoria_numero}
              </Descriptions.Item>
              <Descriptions.Item label="Nombre de la convocatoria">
                {info.convocatoria_nombre}
              </Descriptions.Item>
              <Descriptions.Item label="Cargo/Rol">
                {info.cargo}
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              layout="vertical"
              title="Requisitos de la convocatoria para el cargo"
              column={1}
              bordered
            >
              <Descriptions.Item label="Tipo de educación">
                {info.estudios}&nbsp;
              </Descriptions.Item>
            </Descriptions>
          </Card>
        ) : null}

        {initialValues != null && initialValues.cargo_aplicado !== null && (
          <Alert
            style={{ marginBottom: 10 }}
            message="Atención"
            description={`El usuario también se encuentra aplicando al cargo ${initialValues.cargo_aplicado} de esta convocatoria.
            ¿Desea continuar con el proceso para este cargo?. En caso que no continúe, por favor rechazarlo.`}
            type="error"
            showIcon
          />
        )}
        <Card
          size={'small'}
          bordered={false}
          title={<Title level={3}>{name}</Title>}
        >
          {education != null &&
            education.map((item, index) => (
              <Card
                size={'small'}
                bordered={false}
                title={
                  <Title level={5} className={'title-default'}>
                    Educación No. {index + 1}
                  </Title>
                }
              >
                <Descriptions layout="vertical" column={3} bordered>
                  <Descriptions.Item
                    label={
                      item.tipo_educacion === 1 && item.finalizado
                        ? 'Título obtenido '
                        : 'Nombre del programa'
                    }
                  >
                    {item.titulo_nombre_programa}
                  </Descriptions.Item>
                  <Descriptions.Item label="Estado">
                    {item.finalizado === false ? 'En curso' : 'Finalizado'}
                  </Descriptions.Item>
                  {item.tipo_educacion === 2 &&
                  item.finalizado === false ? null : (
                    <Descriptions.Item
                      label={
                        item.tipo_educacion === 1 && item.finalizado
                          ? 'Fecha de grado '
                          : item.tipo_educacion === 1 && !item.finalizado
                            ? 'Semestre actual'
                            : 'Fecha de terminación'
                      }
                    >
                      {item.tipo_educacion === 1 && !item.finalizado
                        ? item.semestre
                        : item.fecha_terminacion}
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label="Certificado">
                    {item.documento_certificado_nombre ? (
                      <CustomButton
                        loading={loadingDocument}
                        onClick={() => {
                          showDocument(item.documento_certificado_nombre);
                        }}
                        text={'Ver documento'}
                      />
                    ) : (
                      <Text>No se encontró documento</Text>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Tarjeta profesional">
                    {item.documento_tarjeta_profesional_nombre ? (
                      <CustomButton
                        loading={loadingDocument}
                        onClick={() => {
                          showDocument(
                            item.documento_tarjeta_profesional_nombre,
                          );
                        }}
                        text={'Ver documento'}
                      />
                    ) : (
                      <Text>No se encontró documento</Text>
                    )}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            ))}
        </Card>
        {initialValues != null && (
          <Card size={'small'} bordered={false}>
            <Form
              onFinish={onFinish}
              initialValues={initialValues}
              layout="vertical"
            >
              <Form.Item
                rules={[
                  {
                    required: true,
                  },
                ]}
                name="estado_educacion_seleccion"
                label="Estado selección educación"
              >
                <Select disabled={initialValues.estado_seleccion === 21}>
                  {optionPreselection.map((item) => (
                    <Select.Option value={item.id}>{item.nombre}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                {...tailLayout}
                name="observacion_educacion_seleccion"
                label="Observación general Educación"
              >
                <TextArea
                  disabled={initialValues.estado_seleccion === 21}
                  rows={4}
                />
              </Form.Item>
              <Space>
                {initialValues.estado_seleccion !== 21 && (
                  <CustomButton loading={loading} text="Guardar" />
                )}
                <CustomButton
                  type={'default'}
                  className={'back-button'}
                  htmlType="button"
                  onClick={back}
                  text="Volver"
                />
              </Space>
            </Form>
          </Card>
        )}
      </Skeleton>
    </Content>
  );
};

export default AnnouncementSelectionValidationEducation;
